import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import * as fromRoot from "../../../reducers/index";
import * as featureFlag from "../../shared/services/feature-flag-store/feature-flag.actions";
import { ConfigurationService } from "./configuration.service";
import { DataService } from "./data.service";

@Injectable({
  providedIn: "root",
})
export class AzureFeatureFlagService {
  constructor(
    private configService: ConfigurationService,
    private dataService: DataService,
    private store: Store<fromRoot.State>,
  ) {}

  async loadFeatureFlagSettings() {
    if (!this.configService.serverSettings) {
      return false;
    }
    try {
      const features = Object.values(FeatureFlag);
      for (let i = 0; i < features.length; i++) {
        const feature = features[i];
        const enabled = await this.dataService
          .get(
            `${this.configService.serverSettings.ePermitsUrl}/api/v1/FeatureFlag?key=${feature}`,
          )
          .toPromise();

        this.store.dispatch(
          new featureFlag.SetFeatureFlagValueAction({
            key: feature.toString(),
            value: enabled,
          }),
        );
      }
    } catch (error) {
      return false;
    }
  }

  featureEnabled(featureName: string) {
    return this.store.select((state) =>
      fromRoot.getFeatureFlagByKey(state, featureName),
    );
  }
}

export enum FeatureFlag {
  "DashboardBeta" = "EPermits-Ui-Dashboard-Beta",
  "EPermits-SystemAdmin-Create" = "EPermits-SystemAdmin-Create",
  "EPermits-Login-InactivityPolicy" = "EPermits-Login-InactivityPolicy"
}
